import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class PageNotAllowed extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let stores = JSON.parse(localStorage.getItem('storeData'));
    stores.sort();
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: this.props.location.state.id,
      data: [],
      alert: '',
      incType: '',
      //storeValue: stores[0].storeId,
      storeValue: '',
      storeSelected: false,
      closure: '',
      stores,
      wareHouses,
      user: menu,
      pageAllowed: false,

      modalOpen: false,
      visible: false,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      submittedByCodeJson: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      empSubmit: false,
      loading: false,
      submittedBy: '',
    };
  }

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Handover'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );

    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
        visible: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
  }
  render() {
    const { loading, modalOpen, pageAllowed, message } = this.state;
    const style = {
      display: 'block',
      marginTop: '15%',
      marginLeft: 'auto',
      marginRight: 'auto',
      textAlign: 'center',
      width: '50%',

      marginBottom: '35%',
    };
    const welHeader = {
      fontWeight: 'bold',
      fontSize: '300%',
      color: ' #ec6607',
      fontFamily: 'Roboto Condensed',
      fontStyle: 'italic',
    };
    const welHeader1 = {
      fontWeight: 'bold',
      fontSize: '200%',
      color: ' #0082c3',
      fontFamily: 'Roboto Condensed',
      fontStyle: 'italic',
    };

    return (
      <>
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}
        {!pageAllowed ? (
          <MessageBoxForInvalidPage message={this.state.message} />
        ) : null}
        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row'>
                  <div className='content-wrapper10'>
                    <div className='align-center' style={style}>
                      <h1 style={welHeader}>
                        You don't have access to view this page.
                      </h1>
                      <p style={welHeader1}>
                        Please contact your administrator to get access.
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default PageNotAllowed;
